export const FETCH_VACATION_RENTAL_SHOP =
  "vacationRentalShop/FETCH_VACATION_RENTAL_SHOP";
export type FETCH_VACATION_RENTAL_SHOP = typeof FETCH_VACATION_RENTAL_SHOP;

export const SET_VACATION_RENTAL_SHOP_RESULTS =
  "vacationRentalShop/SET_VACATION_RENTAL_SHOP_RESULTS";
export type SET_VACATION_RENTAL_SHOP_RESULTS =
  typeof SET_VACATION_RENTAL_SHOP_RESULTS;

export const SET_VACATION_RENTAL_SHOP_CALL_STATE_FAILED =
  "vacationRentalShop/SET_VACATION_RENTAL_SHOP_CALL_STATE_FAILED";
export type SET_VACATION_RENTAL_SHOP_CALL_STATE_FAILED =
  typeof SET_VACATION_RENTAL_SHOP_CALL_STATE_FAILED;

export const SELECT_HOME = "vacationRentalShop/SELECT_HOME";
export type SELECT_HOME = typeof SELECT_HOME;

export const SET_SELECTED_LISTING_ID =
  "vacationRentalShop/SET_SELECTED_LISTING_ID";
export type SET_SELECTED_LISTING_ID = typeof SET_SELECTED_LISTING_ID;

export const SET_NOTIFY_IF_SHOP_AND_BOOK_PRICE_DIFFER_FLAG =
  "vacationRentalShop/SET_NOTIFY_IF_SHOP_AND_BOOK_PRICE_DIFFER_FLAG";
export type SET_NOTIFY_IF_SHOP_AND_BOOK_PRICE_DIFFER_FLAG =
  typeof SET_NOTIFY_IF_SHOP_AND_BOOK_PRICE_DIFFER_FLAG;

export const SET_LISTING_CALENDAR = "vacationRentalShop/SET_LISTING_CALENDAR";
export type SET_LISTING_CALENDAR = typeof SET_LISTING_CALENDAR;

export const SET_VACATION_RENTAL_ENTRY_SOURCE =
  "vacationRentalShop/SET_VACATION_RENTAL_ENTRY_SOURCE";
export type SET_VACATION_RENTAL_ENTRY_SOURCE =
  typeof SET_VACATION_RENTAL_ENTRY_SOURCE;

export const SET_VACATION_RENTAL_ENTRY_POINT =
  "vacationRentalShop/SET_VACATION_RENTAL_ENTRY_POINT";
export type SET_VACATION_RENTAL_ENTRY_POINT =
  typeof SET_VACATION_RENTAL_ENTRY_POINT;

export const SET_VACATION_RENTAL_SORT_ORDER =
  "vacationRentalShop/SET_VACATION_RENTAL_SORT_ORDER";
export type SET_VACATION_RENTAL_SORT_ORDER =
  typeof SET_VACATION_RENTAL_SORT_ORDER;

export const SET_SELECTED_HOME_IS_FAVORITED =
  "vacationRentalShop/SET_SELECTED_HOME_IS_FAVORITED";
export type SET_SELECTED_HOME_IS_FAVORITED =
  typeof SET_SELECTED_HOME_IS_FAVORITED;

export const SET_LIST_PRICE = "vacationRentalShop/SET_LIST_PRICE";
export type SET_LIST_PRICE = typeof SET_LIST_PRICE;
